import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="feedback" id="top">
        <div className="coustom_container">
          <h1 className="boost_bid_text_para_h1">Privacy Policy</h1>

          <p className="boost_bid_text_para">
            We, Kior healthcare Pvt Ltd, are registered at Plot No. C210P,
            Industrial Area, Phase-8b, Mohali, India, hereinafter referred to as
            “KHC”. At KHC, we value your trust & respect your privacy. This
            Privacy Policy provides you with details about the manner in which
            your data is collected, stored & used by us. You are advised to read
            this Privacy Policy carefully. By downloading and using Kior
            Healthcare (www.kiorhealthcare.com) website/patient portal
            (www.kiorhealthcare.com), you expressly give us consent to use &
            disclose your personal information in accordance with this Privacy
            Policy. If you do not agree to the terms of the policy, please do
            not use or access www.kiorhealthcare.com.
          </p>

          <p className="boost_bid_text_para">
            We will not sell, share, or rent your personal information to any
            third party or use your email address/mobile number for unsolicited
            emails and/or SMS. Any emails and/or SMS sent by KHC will only be in
            connection with the provision of agreed services & products and this
            Privacy Policy. Periodically, we may reveal general statistical
            information about KHC and its users, such as the number of visitors,
            number and type of services availed by our customers, etc. We
            reserve the right to communicate your personal information to any
            third party that makes a legally-compliant request for its
            disclosure.
          </p>

          <h2>What Information We Collect</h2>
          <p className="boost_bid_text_para">Two types of information:</p>

          <h4 className="boost_bid_text_para_h4">
            A) User Provided Information:
          </h4>
          <p className="boost_bid_text_para">
            However, please keep in mind that you may not be able to use some of
            the features offered unless you register with us.
          </p>
          <p className="boost_bid_text_para">
            Our app helps users book medical tests such as ECG, MRI, blood
            tests, and more from certified diagnostic labs. We also provide home
            sample collection services for user convenience. To enable these
            services, the app may collect personal information such as name,
            phone number, address, and location data. Location data is used to:
          </p>
          <ul className="boost_bid_text_para">
            <li>Enable accurate home sample collection</li>
            <li>Match users with nearby diagnostic centers</li>
            <li>
              Assist phlebotomists or healthcare professionals in navigating to
              the user's location
            </li>
          </ul>
          <p className="boost_bid_text_para">
            Location data may be collected in the background only when necessary
            for scheduled appointments or real-time updates related to sample
            collection. This data is collected with user consent and can be
            turned off at any time via device settings. We do not sell or share
            personal or location data with advertisers or third parties for
            marketing purposes. All user data is handled securely and in
            compliance with applicable privacy laws. Users have full control
            over their data, including the ability to request data deletion. For
            more details on data handling, collection, usage, and security
            practices, please refer to our full privacy policy at the link
            provided.
          </p>

          <h4 className="boost_bid_text_para_h4">When You Register With Us</h4>
          <p className="boost_bid_text_para">
            You generally provide the following:
          </p>
          <ul className="boost_bid_text_para">
            <li>
              Your Name, Email Address, Age, User Name, and other registration
              information like address;
            </li>
            <li>
              Transaction-related information, such as when you book a test,
              respond to any offers, or download;
            </li>
            <li>Information you provide us when you contact us for help;</li>
            <li>Credit card/payment information for booking a test, and;</li>
            <li>
              Information you enter into our system such as contact information.
            </li>
          </ul>

          <h4 className="boost_bid_text_para_h4">
            B) Automatically Collected Information
          </h4>
          <p className="boost_bid_text_para">
            Personal Information refers to all information that can be linked to
            a specific individual, such as name, address, mailing address,
            telephone number, email ID, mobile phone information, and any
            details that may have been voluntarily provided by the user in
            connection with availing any of the services at KHC.
          </p>

          <h2>Use of Personal Information</h2>
          <p className="boost_bid_text_para">We use personal information to:</p>
          <ul className="boost_bid_text_para">
            <li>
              Provide you with services & products you explicitly requested for;
            </li>
            <li>
              Resolve disputes, troubleshoot concerns, help promote safe
              services;
            </li>
            <li>
              Collect money, measure consumer interest in our services, inform
              you about offers, products, services, updates;
            </li>
            <li>
              Customize your experience, detect & protect us against errors,
              fraud, and other criminal activity;
            </li>
            <li>Enforce our terms and conditions, etc.</li>
          </ul>
          <p className="boost_bid_text_para">
            We also use your contact information to send you offers based on
            your previous orders and interests. We may occasionally ask you to
            provide feedback about your experience as a customer through online
            surveys. These surveys may ask for contact information and
            demographic information (such as PIN code, age, gender, etc.). We
            use this data to customize your experience at KHC. We will also use
            the usage information collected using measuring and analytic tools
            to learn how we can improve it in future updates. Your payment is
            processed by our payment partners. The sensitivity of your
            information with our payment information can be found by contacting
            the respective payment service providers.
          </p>

          <h2>Disclosure of User Information</h2>
          <p className="boost_bid_text_para">
            We may disclose user-provided information and automatically
            collected information:
          </p>
          <ul className="boost_bid_text_para">
            <li>
              As required by law, such as to comply with a subpoena or similar
              legal process;
            </li>
            <li>
              When we believe in good faith that disclosure is necessary to
              protect our rights, your safety, the safety of others, investigate
              fraud, or respond to a government request;
            </li>
            <li>
              With our trusted service providers who work on our behalf, and do
              not have an independent use of the information we disclose to
              them, and have agreed to adhere to the rules set forth in this
              Privacy Statement;
            </li>
            <li>
              With third parties to help you navigate to our nearest service
              location.
            </li>
          </ul>
          <p className="boost_bid_text_para">
            KHC reserves the right to contact you for direct marketing messages
            through SMS, email, or phone call.
          </p>

          <h2>Data Retention Policy</h2>
          <p className="boost_bid_text_para">
            KHC reserves the right to retain the user-provided data and
            automatically collected data for an indefinite time thereafter.
          </p>

          <h2>Security</h2>
          <p className="boost_bid_text_para">
            KHC is concerned about safeguarding the confidentiality of your
            information. We have stringent security measures in place to protect
            the loss, misuse, and alteration of the information under our
            control. Please be aware that, although we endeavor to provide
            reasonable security for the information we process and maintain, no
            security system can prevent all potential security breaches.
          </p>

          <h2>Changes to the Privacy Policy</h2>
          <p className="boost_bid_text_para">
            Our Privacy Policy may be updated or changed from time to time for
            any reason without prior notification. You are advised to consult
            this Privacy Policy regularly for any changes and review the policy
            periodically. You consent to the collection and use of the
            information you disclose in accordance with this Privacy Policy,
            including but not limited to your consent for sharing your
            information as per this Privacy Policy.
          </p>

          <h2>Contact Us</h2>
          <p className="boost_bid_text_para">
            If you have any questions regarding privacy, or have questions about
            our practices, please contact us via email at{" "}
            <Link to="mailto:kiorhealthcare8b@gmail.com">
              kiorhealthcare8b@gmail.com
            </Link>{" "}
            or by calling our customer care at 8263000004.
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
